import { MouseEventHandler, ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TMap } from '@shared/types';

type TParams = {
  // An undefined value removes its parameter; the other parameters stay.
  params: TMap<string, string | undefined>;
  children: ReactNode;
  replace?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};
const QueryLink = ({ params, children, replace, onClick }: TParams) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  for (const [key, value] of Object.entries(params)) {
    if (value) searchParams.set(key, value);
    else searchParams.delete(key);
  }

  const href = `${location.pathname}?${searchParams.toString()}`;

  return (
    <Link to={href} replace={replace} onClick={onClick}>
      {children}
    </Link>
  );
};

export { QueryLink };
